import { useState } from "react";

import { getOpenMap } from "../../../store/selectors";
import { usePublicationStore } from "../../../store/store";
import { Layer } from "../../../types/publication";

import { useLayerDrag } from "./use-layer-drag";
import { useLayerSelection } from "./use-layer-selection";

export function useLayerList() {
  const { layers } = usePublicationStore(getOpenMap);
  const [removeModalFor, setRemoveModalFor] = useState<Layer | null>(null);
  const openRemoveLayerModal = (layer: Layer) => setRemoveModalFor(layer);
  const closeRemoveLayerModal = () => setRemoveModalFor(null);

  const { handleLayerClick } = useLayerSelection();
  const drag = useLayerDrag();

  return {
    layers,
    removeModalFor,
    openRemoveLayerModal,
    closeRemoveLayerModal,
    handleLayerClick,
    ...drag,
  };
}
